module.exports = __webpack_public_path__ + "img/banner_introduce.94590684.png";